export const REPORTS_NAMESPACE_TRANSLATIONS = {
  generateReport: {
    title: "Generar Informes",
    description:
      "Genera informes sobre los animales de la granja con información relacionada con raza, especie, sexo y sus datos relevantes.",
    note: "Los informes estarán disponibles en la sección Informes después de la generación, esto puede tardar hasta 15 segundos.",
    pending: "Generando informe...",
    success: "¡Informe generado exitosamente!",
    error: "Error al generar el informe. Inténtalo de nuevo.",
    button: "Generar Informe de Animales",
    buttonGenerating: "Generando...",
  },

  individualAnimalReports: {
    title: "Informes Individuales de Animales",
    description:
      "Genere informes detallados sobre un animal, reproducción, salud y productividad.",
    note: "Los informes estarán disponibles a continuación después de la generación, esto puede tardar hasta 15 segundos.",
    button: "Generar informe de animal",
  },

  filters: {
    all: "Todos los Informes",
    animal: "Informes de Animales",
    financial: "Informes Financieros",
    production: "Informes de Producción",
  },

  status: {
    pending: "Pendiente",
    processing: "Procesando",
    completed: "Completado",
    failed: "Fallido",
  },
}
